var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.513 9.654a2.667 2.667 0 00-2.667-2.667H16.85c.053 0 .036-.021-.081-.164l-.105-.128a35.763 35.763 0 01-.418-.536C15.29 4.954 14.34 4.32 12.846 4.32h-8A2.667 2.667 0 002.18 6.987v18.667a2.667 2.667 0 002.666 2.666h24a2.667 2.667 0 002.667-2.666v-16zm-2.667 0v16h-24V6.987h8c.513 0 .81.198 1.31.828l.116.15c.107.138.255.329.316.404.67.831 1.294 1.28 2.251 1.285h12.007z",
    fill: "#2C5BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.846 17.653a4 4 0 11-8 0 4 4 0 018 0zm-10.666 0a6.667 6.667 0 1013.333 0 6.667 6.667 0 00-13.333 0zm14.666-5.333a1.333 1.333 0 102.667 0 1.333 1.333 0 00-2.667 0z",
    fill: "#2C5BFF"
  })));
}
export default __webpack_public_path__ + "media/landing/photo-icon-241e22d7.svg";
export { SvgPhotoIcon as ReactComponent };